import { AvProxyApi } from '@availity/api-axios';

const transactionProxy = new AvProxyApi({ tenant: 'anthem', name: 'v1/providerapp/logging/transactions' });

const transactions = params => {
  transactionProxy.post(params)
      .catch(()=>{});
}

export default transactions;